import React from 'react';
import PropTypes from 'prop-types';

const SvgFullScreen = ({ active, ...props }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 26 26" {...props}>
            <rect width="24.2" height="24.2" x="1" y="1" fill="#EAEBF0" stroke="#343A72" strokeWidth="1.25" rx="4" />
            <path
                stroke="#343A72"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="m8.7 17.5-3.3 3.3m2.75 0H5.4v-2.75m12.1-.55 3.3 3.3m-2.75 0h2.75v-2.75M8.7 8.7 5.4 5.4m2.75 0H5.4v2.75m12.1.55 3.3-3.3m-2.75 0h2.75v2.75"
            />
        </svg>
    );
};
SvgFullScreen.propTypes = {
    active: PropTypes.bool,
};
SvgFullScreen.defaultProps = {
    active: false,
};

export default SvgFullScreen;
